'use strict';

angular.module('shiftTraderApp')
  .controller('BaseQuickAddRowCtrl', function BaseSmartCWPCtrl($scope, params, $filter,
                                                            $timeout, $interval, $log, $rootScope, toastr,
                                                            TimeService, $uibModalInstance, ShepherdTourService) {
    var _this = this;


    $scope.org = params.org;
    $scope.allPositions = params.allPositions;
    $scope.orgDayStartHour = $scope.org.organization_config.work_day_start_hour;


    $scope.close = function() {
      $uibModalInstance.dismiss();
    };

    // only use ACTIVE departments with at least 1 active position
    $scope.allDepartments = _(_.cloneDeep($scope.org.departments)).where({active: true})
      .map(function(dept) {
        dept.positions = _.where($scope.allPositions, {department_id: dept.id, active: true});
        return dept;
      })
      .where(function(dept) { return dept.positions && dept.positions.length > 0;})
      .value();


    $scope.allPositionsOrdered = [];

    _.each($scope.allDepartments, function(dept) {
      $scope.allPositionsOrdered.push.apply($scope.allPositionsOrdered, dept.positions);
    });

    $scope.positionRows = [];
    $scope.totalShifts = 0;

    $scope.groupByFn = function(pos) {
      var idx = _.findIndex($scope.allDepartments, {id: pos.department_id});

      if (idx > -1) {
        return $scope.allDepartments[idx].name;
      } else {
        return '';
      }
    };


    this.calcTotalShifts = function() {
      $scope.totalShifts = _.reduce(_.map($scope.positionRows, function(row) {
        return _.where(row.objects, function(obj) {
          return obj.d.parsed;
        }).length;
      }), function(sum, num) {
        return sum + num;
      });
    };

    this.isLastDept = function(deptId) {
      var deptIdx = _.findIndex($scope.allDepartments, {id: deptId});

      return deptIdx === ($scope.allDepartments.length -1);
    };

    this.isLastPosInDept = function(pos) {
      var deptId = pos.department_id;
      var dept = _.find($scope.allDepartments, {id: deptId});
      var posIdx = _.findIndex(dept.positions, {id: pos.id});

      return posIdx === (dept.positions.length -1);
    };

    this.lastPosIsSelected = function(pos) {
      var dept = _.find($scope.allDepartments, {id: pos.department_id});

      if (_this.isLastDept(pos.department_id)) {
        var pos = _.find(dept.positions, {id: pos.id});
        return _this.isLastPosInDept(pos);
      } else {
        return false;
      }
    };


    this.simplifyEntries = function(allEntries) {
      // loop over the entries and look for repeated shifts, simplifying things
      var simplifiedEntries = [];

      var tempEntry = ''; // where we keep the value of the previous array index
      var numTimes = 1; // the number of times a time interval has been repeated

      _.each(allEntries, function(entry, idx) {
        var strippedEntry = entry.replace( /^\s+|\s+$/g, '' );
        if (idx > 0) {
          // this algorithm is looking at the previous index in the array, so we're always adding tempEntry, NOT strippedEntry is this clause
          if (strippedEntry !== tempEntry) {
            if (numTimes > 1) {
              simplifiedEntries.push(tempEntry + '*' + numTimes);
              numTimes = 1;
            } else {
              simplifiedEntries.push(tempEntry);
            }
          } else {
            // if last index and current index are the same, just bump the number of times we've seen it.
            numTimes += 1;
          }
        }

        // at the end of each iteration, set temp = stripped
        tempEntry = strippedEntry;

        // if we're at the end of the array, add strippedEntry (and possibly add a multiplier if necessary
        if (allEntries.length === (idx + 1)) {
          if (numTimes > 1) {
            simplifiedEntries.push(strippedEntry + '*' + numTimes);
          } else {
            simplifiedEntries.push(strippedEntry);
          }
        }
      });

      return simplifiedEntries;
    };

    this.parseRawText = function(rawText) {
      // first, just split it on comma and get an array of possibilities.
      // trim whitespace off of both sides
      var entries = _.invoke(rawText.split(','), 'trim');

      // only take entries that are length 1 or greater once trimmed
      entries = _.where(entries, function(entry) {
        return entry.length >= 1;
      });

      var processedEntries = [];
      _.each(entries, function(entry) {
        // split on * to see if we have a multiplier
        var numTimes = 1;
        if (_.contains(entry, '*')) {
          numTimes = parseInt(_.last(entry.split('*')));
          entry = entry.split('*')[0];
        }

        var p = TimeService.parseRawStartEndTimeString(entry, $scope.currentDate);
        processedEntries.push(_.map(_.range(numTimes), function(idx) {
          return {
            d: p,
            idx: idx,
            totalRepeated: numTimes
          };
        }));

      });

      processedEntries = _.flatten(processedEntries);

      var nowTime = TimeService.getNowInStoreTime();
      _.each(processedEntries, function(entry) {
        if (entry.d.parsed && (entry.d.start.dt.isBefore(nowTime) || entry.d.start.dt.isSame(nowTime))) {
          entry.d._beforeNow = true;
        } else {
          entry.d._beforeNow = false;
        }
      });

      return processedEntries;
    };


    $scope.nextPos = function(pos) {
      var initDeptIdx = _.findIndex($scope.allDepartments, {id: pos.department_id});
      var initPosIdx = _.findIndex($scope.allDepartments[initDeptIdx].positions, {id: pos.id});

      var getNextIndexes = function(p) {
        var posIdx, deptIdx;
        if (!_this.lastPosIsSelected(p)) {
          var dept = _.find($scope.allDepartments, {id: p.department_id});

          deptIdx = _.findIndex($scope.allDepartments, {id: p.department_id});

          if (_this.isLastPosInDept(p)) {
            posIdx = 0;
            deptIdx += 1;
          } else {
            posIdx = _.findIndex(dept.positions, {id: p.id}) + 1;
          }
        } else {
          //find the first position in a department
          _.each($scope.allDepartments, function(dept, idd) {
            var foundPosition = false;
            _.each(dept.positions, function(z, idp) {
              foundPosition = true;
              posIdx = idp;
              deptIdx = idd;
              return false;
            });

            if (foundPosition) {
              return false;
            }
          });
        }

        return {
          posIdx: posIdx,
          deptIdx: deptIdx
        };
      };


      var keepSearching = true;
      var testIndices = {
        deptIdx: initDeptIdx,
        posIdx: initPosIdx
      };

      var currPos = pos;
      var testPos;

      while (keepSearching) {
        currPos = $scope.allDepartments[testIndices.deptIdx].positions[testIndices.posIdx];
        testIndices = getNextIndexes(currPos);
        testPos = $scope.allDepartments[testIndices.deptIdx].positions[testIndices.posIdx];

        // check to see if result already has a row or not

        if (!_.contains(_.pluck($scope.positionRows, 'positionId'), testPos.id)) {
          keepSearching = false;
        }

        if (testPos.id === pos.id) {
          // we got to the same place we started and still haven't found an open match
          toastr.error('No more positions to add.', 'Error');
          return undefined;
        }
      }

      return {
        department_idx: testIndices.deptIdx,
        position_idx: testIndices.posIdx
      };
    };


    var scrollTimeout;
    $scope.addAnotherRow = function() {
      var nextPositionId, nextIdxs, temp;

      if ($scope.positionRows.length > 0) {
        // look for the id of the last position row
        temp = _.find($scope.allPositionsOrdered, {id: parseInt(_.last($scope.positionRows).positionId)});

        //console.log($scope.positionRows);
        nextIdxs = $scope.nextPos(temp);

        if (nextIdxs) {
          nextPositionId = $scope.allDepartments[nextIdxs.department_idx].positions[nextIdxs.position_idx].id;
        } else {
          // if nextIdxs is undefined, just exit!
          return false;
        }

      } else {
        nextPositionId = $scope.allPositionsOrdered[0].id;
      }

      $scope.positionRows.push({
        positionId: nextPositionId,
        rawText: '',
        objects: []
      });

      var idx = $scope.positionRows.length - 1;
      $scope.$watch(function() {
        return $scope.positionRows[idx].rawText;
      }, (function (idx) {
        return function (newVal) {
          console.log('WATCH FIRED: ', idx, ': ', newVal);
          var res = _this.parseRawText(newVal);

          $scope.positionRows[idx].objects = res;

          _this.calcTotalShifts();

          // if it was the LAST positionRow that got modified then
          // scroll to the top of the container automatically
          if ((idx + 1) === $scope.positionRows.length) {
            $timeout(function() {
              $('.quick_add_position_rows_container').animate({
                scrollTop: $('.quick_add_position_rows_container').prop('scrollHeight')
              }, 300);
            }, 500);
          }
        };
      })(idx));


      // scroll to the bottom of the window
      // use $timeout because we need to wait for the animation to finish to get the real height

      // if scrollTimeout is defined THEN that means there is an animation queued... cancel it.
      if (scrollTimeout) {
        $timeout.cancel(scrollTimeout);
      }

      scrollTimeout = $timeout(function() {
        $('.quick_add_position_rows_container').animate({
          scrollTop: $('.quick_add_position_rows_container').prop('scrollHeight')
        }, 300);
        $('.quick_add_position_row').last().find('.quick_add_shift_input_container input').focus();
      }, 500);

      ShepherdTourService.triggerEvent('quickAddPositionRow');
    };

    $scope.removeShift = function(rowIdx, objIdx) {
      var allEntries = _.map($scope.positionRows[rowIdx].objects, function(obj) { return obj.d.rawText});
      allEntries.splice(objIdx, 1);

      $scope.positionRows[rowIdx].rawText = _this.simplifyEntries(allEntries).join(', ');
    };


  });
